
export default function Welcome() {
  return (
    <div className="lg:col-span-2 lg:bloc">
      <div className="pl-5">
        <div className="text-center">
          <h2 className="text-xl text-gray-500 dark:text-gray-400">
            Select a Chat to Start Messaging
          </h2>
        </div>
      </div>
    </div>
  );
}